import React from 'react'

export default function IconAI (props) {
  return (
    <svg
      width="27"
      height="27"
      viewBox="0 0 27 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      {...props}
      aria-hidden="true"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 13.5V0H3.78C9.14821 0 13.5 4.35179 13.5 9.71999V13.5H0ZM27 13.5V27H23.22C17.8518 27 13.5 22.6482 13.5 17.28V13.5L27 13.5ZM27 0H13.5L13.5 13.5L17.28 13.5C22.6482 13.5 27 9.14821 27 3.78V0ZM13.5 27H0V23.22C0 17.8518 4.35179 13.5 9.71999 13.5H13.5V27Z"
        fill="#5CEBA0"
      />
    </svg>
  )
}
